<!--==============================
=            TOOLTIPS            =
===============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Tooltip</div>
      </base-header>
    </v-row>
<v-row>
				<v-col class="col-12 col-md-12 col-sm-12">
					<base-card >
						<div slot="card-header">#Usage</div>
						<div slot="card-subheader">Tooltips can wrap any element.

						</div>
						<div slot="card-body">
							<div class="text-center d-flex align-center justify-space-around">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="primary"
											   dark
											   v-bind="attrs"
											   v-on="on">
											Button
										</v-btn>
									</template>
									<span>Tooltip</span>
								</v-tooltip>

								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-icon color="primary"
												dark
												v-bind="attrs"
												v-on="on">
											mdi-home
										</v-icon>
									</template>
									<span>Tooltip</span>
								</v-tooltip>

								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<span v-bind="attrs"
											  v-on="on">This text has a tooltip</span>
									</template>
									<span>Tooltip</span>
								</v-tooltip>
							</div>
						</div>
					</base-card>
				</v-col>
				<v-col class="col-12 col-md-12 col-sm-12">
					<base-card >
						<div slot="card-header">#Alignment</div>
						<div slot="card-subheader">A tooltip can be aligned to any of the four sides of the activator
							element.</div>
						<div slot="card-body">
							<div class="text-center d-flex align-center justify-space-around">
								<v-tooltip left>
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="primary"
											   dark
											   v-bind="attrs"
											   v-on="on">
											Left
										</v-btn>
									</template>
									<span>Left tooltip</span>
								</v-tooltip>

								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="primary"
											   dark
											   v-bind="attrs"
											   v-on="on">
											Top
										</v-btn>
									</template>
									<span>Top tooltip</span>
								</v-tooltip>

								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="primary"
											   dark
											   v-bind="attrs"
											   v-on="on">
											Bottom
										</v-btn>
									</template>
									<span>Bottom tooltip</span>
								</v-tooltip>

								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="primary"
											   dark
											   v-bind="attrs"
											   v-on="on">
											Right
										</v-btn>
									</template>
									<span>Right tooltip</span>
								</v-tooltip>
							</div>
						</div>
					</base-card>
				</v-col>
				<v-col class="col-12 col-md-12 col-sm-12">
					<base-card >
						<div slot="card-header">#Color</div>
						<div slot="card-subheader">Tooltip color can be set with the color prop</div>
						<div slot="card-body">
							<div class="text-center d-flex align-center justify-space-around">
								<v-tooltip bottom
										   color="primary">
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="primary"
											   dark
											   v-bind="attrs"
											   v-on="on">
											primary
										</v-btn>
									</template>
									<span>Primary tooltip</span>
								</v-tooltip>

								<v-tooltip bottom
										   color="success">
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="success"
											   dark
											   v-bind="attrs"
											   v-on="on">
											success
										</v-btn>
									</template>
									<span>Success tooltip</span>
								</v-tooltip>

								<v-tooltip bottom
										   color="warning">
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="warning"
											   dark
											   v-bind="attrs"
											   v-on="on">
											warning
										</v-btn>
									</template>
									<span>Warning tooltip</span>
								</v-tooltip>

								<v-tooltip bottom
										   color="error">
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="error"
											   dark
											   v-bind="attrs"
											   v-on="on">
											error
										</v-btn>
									</template>
									<span>Error tooltip</span>
								</v-tooltip>
							</div>
						</div>
					</base-card>
				</v-col>
				<v-col class="col-12 col-md-12 col-sm-12">
					<base-card >
						<div slot="card-header">#Visibility</div>
						<div slot="card-subheader">.Tooltip visibility can be programmatically changed using v-model.
						</div>
						<div slot="card-body">
							<v-container fluid
										 class="text-center">
								<v-row class="flex"
									   justify="space-between">
									<v-col cols="12">
										<v-btn @click="show = !show">
											toggle
										</v-btn>
									</v-col>

									<v-col cols="12"
										   class="mt-12">
										<v-tooltip v-model="show"
												   top>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon
													   v-bind="attrs"
													   v-on="on">
													<v-icon color="grey lighten-1">
														mdi-cart
													</v-icon>
												</v-btn>
											</template>
											<span>Programmatic tooltip</span>
										</v-tooltip>
									</v-col>
								</v-row>
							</v-container>
						</div>
					</base-card>
				</v-col>
			</v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },data() {
			return {
				show: false,
			}
		},
    
  }
</script>


<!--====  End of TOOLTIPS  ====-->
